import React, { useEffect, useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Group76 from "../../../safreeimg/Group 76.png";
import Loader from '../../../safreeimg/loader.gif';
import leftarrow from '../../../safreeimg/left-arrow.png'


const OrganizationMember = () => {
    const [organisations, setOrganisations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    const rowsPerPage = 10;
    const navigate = useNavigate();  
    useEffect(() => {
        const fetchOrganisations = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    setError('No authentication token found');
                    setLoading(false);
                    return;
                }

                const hash = window.location.hash.substring(1); 
                if (!hash) {
                    setError('No ID found in the URL hash');
                    setLoading(false);
                    return;
                }

                console.log('Extracted ID:', hash);
                console.log('Token:', token);

                const response = await axios.get(
                    `https://api.safree.org/api-v2022/superAdmin/auth/v1/orgUsers/${hash}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                console.log('API Response:', response);

                if (response.data && Array.isArray(response.data.data)) {
                    setOrganisations(response.data.data);
                } else {
                    setError('Invalid data format from API');
                }
            } catch (err) {
                console.error('Error fetching organisations:', err);
                setError('An error occurred while fetching organisations: ' + err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchOrganisations();
    }, []);

    const totalPages = Math.ceil(organisations.length / rowsPerPage);
    const currentRows = organisations.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (direction) => {
        if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    if (loading) return <div className="loading"><img src={Loader} alt="Loading" /></div>;

    if (error) return <div>Error: {error}</div>;
    const handleBackClick = () => {
        navigate(-1);  
      };
    return (
        <div className="container user-management">
            {/* Header Section */}
            <div className="row header">
                <div className="col-md-6">
                    <p className="sub-heading"><img  onClick={handleBackClick} className="back-button" src={leftarrow} alt="" />Organization Member</p>
                </div>
            </div>

            <div className="content-wrapper">
                {/* Table Section */}
                <div className="table-container">
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone No</th>
                                <th>Profile Image</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRows.map((organisation, index) => (
                                <tr key={organisation._id}>
                                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                                    <td>{organisation.name}</td>
                                    <td>{organisation.email}</td>
                                    <td>{organisation.phoneNumber}</td>
                                    {/* <td>
                                        <button className="btn btn-view">View Details</button>
                                    </td> */}
                                    <td>
                                        {organisation.logo ? (
                                            <img
                                                src={organisation.profileImage}
                                                alt="Organisation Logo"
                                                style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                            />
                                        ) : (
                                            <span>No Image Available</span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {/* Pagination Section */}
                    <div className="pagination-container">
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange('prev')}
                            disabled={currentPage === 1}
                        >
                            &laquo; Prev
                        </button>
                        {Array.from({ length: totalPages }, (_, index) => (
                            <button
                                key={index}
                                className={`pagination-btn ${currentPage === index + 1 ? 'active' : ''}`}
                                onClick={() => setCurrentPage(index + 1)}
                            >
                                {index + 1}
                            </button>
                        ))}
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange('next')}
                            disabled={currentPage === totalPages}
                        >
                            Next &raquo;
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrganizationMember;
